<template>
  <div class="bill-setting" v-loading="loading">
    <TabBtn
      :tabs="tabs"
      :active-tab="tabActive"
      height="100%"
      @tab-click="initData"
    >
      <template slot="btn">
        <el-button
          v-if="tabActive === '3'"
          type="primary"
          size="mini"
          @click="handleImportData"
        >
          导入清单
        </el-button>
      </template>
      <template>
        <LeftRightBox class="page-container" :leftWidthDefault="250">
          <div class="left" slot="left">
            <SimpleTable
              ref="leftTable"
              :show-index="false"
              :allowMultiSelect="false"
              :columns="columnsLeft"
              :data="tableDataLeft"
              @row-select="handleRowSelectLeft"
            />
          </div>
          <div class="right" slot="right">
            <VTable
              ref="vtableRef"
              table-code="billSettingsRight"
              :loading="loadingRight"
              :columns="columnsFilter"
              :data="tableData"
              :contextMenuMap="contextMenuMap"
              :auto-width="true"
              :fill-width="true"
              :max-auto-width="200"
              :default-column-width="120"
              @cell-change="handleCellEdit"
              @backspace="handleBackspace"
            />
          </div>
        </LeftRightBox>
      </template>
    </TabBtn>
  </div>
</template>

<script>
// 导入VTable组件
import VTable from '@/components/VTable/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import { leftMixin } from './leftMixin.js'
import SimpleTable from '@/components/SimpleTable'
import TabBtn from '@/components/TabBtn'
import { tableMixin } from '@/utils/tableMixin'
import { selectFile, debounceAfter, sortRecords } from '@/utils/index'

export default {
  name: 'BillSettings',
  mixins: [leftMixin, tableMixin],
  components: {
    VTable,
    SimpleTable,
    LeftRightBox,
    TabBtn
  },
  data() {
    return {
      // VTable 组件引用
      loading: false,
      loadingRight: false,
      tabActive: '2',

      tabs: [
        { label: '2013清单', value: '1' },
        { label: '2024清单', value: '2' },
        { label: '非国标清单', value: '3' }
      ],

      columns: [
        {
          field: 'code',
          title: '编码',
          canEdit: false,
          width: 'auto' // 使用自适应宽度
        },
        {
          field: 'name',
          title: '名称',
          canEdit: false,
          width: 'auto' // 使用自适应宽度
        },
        {
          field: 'measurementUnit',
          title: '计量单位',
          canEdit: false,
          width: 'auto' // 使用自适应宽度
        },
        {
          field: 'partyaCategoryName',
          editModal: {
            columns: [{ field: 'name', title: '甲方分类' }],
            options: async () => await this.getOptionsPartyaCategoryName(),
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'partyaCategoryName', row.name)
                this.$set(obj, 'partyaCategoryId', row.id)
              })
            }
          },
          canModify: true,
          title: '甲方分类'
        },
        {
          field: 'constructionGroupName',
          editModal: {
            columns: [{ field: 'name', title: '施工班组' }],
            options: async () => await this.getOptionsConstructionGroupName(),
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'constructionGroupName', row.name)
                this.$set(obj, 'constructionGroupId', row.id)
              })
            }
          },
          canModify: true,
          title: '施工班组'
        },
        {
          field: 'regionName',
          title: '所在地区',
          editModal: {
            columns: [{ field: 'name', title: '所在地区' }],
            options: async () => {
              const res = await this.$service.get('/region/list', {})
              return sortRecords(res?.data || [])
            },
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'regionName', row.name)
                this.$set(obj, 'regionId', row.id)
              })
            }
          },
          // canModify: true,
          title: '所在地区'
        },
        {
          field: 'engineeringNature',
          title: '工程性质'
        },
        {
          field: 'valuationIndicatorCategoryName',
          editModal: {
            columns: [
              { field: 'name', title: '指标项', tree: true },
              { field: 'unit', title: '单位' }
            ],
            options: async () =>
              await this.getOptionsValuationIndicatorCategoryName(),
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'valuationIndicatorCategoryName', row.name)
                this.$set(obj, 'valuationIndicatorCategoryId', row.id)
              })
            }
          },
          canModify: false,
          title: '计价指标项'
        },
        {
          field: 'measurementIndicatorCategoryName',
          editModal: {
            columns: [
              { field: 'name', title: '指标项', tree: true },
              { field: 'unit', title: '单位' }
            ],
            options: async () =>
              await this.getOptionsMeasurementIndicatorCategoryName(),
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'measurementIndicatorCategoryName', row.name)
                this.$set(obj, 'measurementIndicatorCategoryId', row.id)
              })
            }
          },
          canModify: false,
          title: '计量指标项'
        }
      ],
      contextMenuMap: {
        查询: (row, record) => this.handleSearch(row),
        批量修改: (row, record) => this.handleEdit(row)
      },

      billLibraryId: ''
    }
  },
  computed: {
    columnsFilter() {
      if (this.tabActive === '3') return this.columns

      return this.columns.filter(
        e => !['engineeringNature', 'regionName'].includes(e.field)
      )
    }
  },
  watch: {
    tabActive() {
      if (this.tabActive === '3') {
        this.contextMenuMap.插入 = () => this.canInsert()
        this.contextMenuMap.批量删除 = (row, record) => this.handleDelete(row)
      } else {
        this.contextMenuMap.插入 = null
        this.contextMenuMap.批量删除 = null
      }

      const props = [
        'constructionGroupName',
        'partyaCategoryName',
        'engineeringNature',
        'regionName'
      ]
      const bol = this.tabActive === '3'
      for (const val of this.columns) {
        if (props.includes(val.field)) continue
        if (!val.editModal) val.canEdit = bol
        val.canModify = bol
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    // 初始化表格数据
    initData(e) {
      if (e) this.tabActive = e.value
      this.getLeftData()
    },

    async getData(row = {}) {
      this.loadingRight = true
      if (row.billLibraryId) this.billLibraryId = row.billLibraryId
      const res = await this.$service.get('/bill-library/detail', {
        code: row.code,
        constructionGroupId: row.constructionGroupId,
        measurementIndicatorCategoryId: row.measurementIndicatorCategoryId,
        measurementUnit: row.measurementUnit,
        name: row.name,
        billLibraryId: this.billLibraryId,
        partyaCategoryId: row.partyaCategoryId,
        valuationIndicatorCategoryId: row.valuationIndicatorCategoryId,
        type: this.tabActive
      })
      if (res?.code === 200) {
        this.tableData = sortRecords(res.data || [])
      }
      this.loadingRight = false
    },

    async getOptionsPartyaCategoryName() {
      const res = await this.$service.get('/partya-category/list', {})
      return sortRecords(res?.data || [])
    },
    async getOptionsConstructionGroupName() {
      const res = await this.$service.get('/construction-group/list', {})
      return sortRecords(res?.data || [])
    },
    async getOptionsValuationIndicatorCategoryName() {
      const res = await this.$service.get('/indicator-category/listAll', {})
      return sortRecords(res?.data || [])
    },
    async getOptionsMeasurementIndicatorCategoryName() {
      const res = await this.$service.get('/indicator-category/listAll', {})
      return sortRecords(res?.data || [])
    },

    canInsert() {
      if (
        this.selectedRowsLeft?.id &&
        !this.selectedRowsLeft?.children?.length
      ) {
        return this.handleInsert()
      } else {
        this.$message.warning('请选择左侧叶子节点数据')
      }
    },

    onModifyDataChange: debounceAfter(async function () {
      const arr = this.getModifyData()
      if (!arr.length) return
      arr.forEach(e => {
        e.type = this.tabActive
      })
      const res = await this.$service.post('/bill-library/detail/batch', arr)
      if (res?.code === 200) {
        arr.forEach((e, i) => {
          if (!e.id && res?.data?.[i]) e.id = res?.data?.[i]
        })
        this.cleanModifyData()
        this.$message.success('保存成功')
      }
    }),

    // 点击导入
    async handleImportData() {
      try {
        const file = await selectFile({
          accept: '.xlsx,.xls',
          multiple: false
        })
        if (file) {
          this.uploadFile(file)
        }
      } catch (error) {
        console.error('文件选择失败:', error)
      }
    },

    async uploadFile(file) {
      this.loading = true
      const formData = new FormData()
      formData.append('file', file)
      const res = await this.$service.post(
        '/billLibrary/importNonStandardBill',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      )
      if (res.code === 200) {
        this.$message.success('导入成功')
        this.initData()
      }
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.vtable-page {
  padding: 12px 16px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;

  .left {
    width: 100%;
    height: 100%;
  }

  .right {
    width: 100%;
    flex: 1;
    height: 100%;
    overflow: hidden;
  }
}

.bill-setting {
  height: 100%;
  width: 100%;
}
</style>
